module.exports = __webpack_public_path__ + "static/media/img-step3@2x.61fc1675.png";